<div class="card">
    <p-accordion [multiple]="true" (activeIndexChange)="handleOnOpen($event)">
        <p-accordionTab header="PTO Policy" [(selected)]="activeState[0]">
            <div [ngStyle]="{ height: tabHeight }">
                <div class="setup">
                    <ef-setup-presenter
                    [accrualsFilterSelectItem]="accrualsFilterSelectItem"
                    [groups]="groups"
                    [policySetup]="policySetup"
                    [accrualPeriods]="accrualPeriods"
                    (SavePolicySetup)="onSavePolicySetup($event)"
                    (DeletePolicySetup)="onDeletePolicySetup($event)"
                    >
                    </ef-setup-presenter>
                </div>
            </div>
        </p-accordionTab>

        <p-accordionTab header="Policy Assignments by Employee" [(selected)]="activeState[1]"  (selectedChange)="onSelectedChargeNumberTab($event)">
            <div [ngStyle]="{ height: tabHeight }">
                <div class="assignment">
                    <ef-assignment-presenter
                    [isQBO]="isQBO"
                    [companySettings]="companySettings"
                    [groups]="groups"
                    [policySetup]="policySetup"
                    [userInfo]="userInfo"
                    [policyAssignment]="policyAssignment"
                    (SavePolicyAssignment)="onSavePolicyAssignment($event)"
                    (UpdateCompanySetting)="onUpdateCompanySetting($event)"
                    >
                    </ef-assignment-presenter>
                </div>
            </div>
        </p-accordionTab>
    </p-accordion>

</div>
